import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../layout/index.vue'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      { path: '/', name: 'Home', component: () => import('@/views/home/index.vue') },
      { path: '/repair', name: 'Repair', component: () => import('@/views/repair/index.vue') },
      { path: '/user', name: 'User', component: () => import('@/views/user/index.vue') }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login/index.vue')
  },
  {
    path: '/appRepair',
    name: 'AppRepair',
    component: () => import('../views/appRepair/index.vue')
  },
  {
    path: '/appRepairApplication',
    name: 'AppRepairApplication',
    component: () => import('../views/appRepairApplication/index.vue')
  },
  {
    path: '/appRepairApplication/success',
    name: 'AppRepairApplicationSuccess',
    component: () => import('../views/appRepairApplication/submitSuccess.vue')
  },
  {
    path: '/appRepairSearch',
    name: 'AppRepairSearch',
    component: () => import('../views/appRepairSearch/index.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
